import React from 'react';
import { connect } from 'react-redux';
import { pathToAction, history, selectLocationState, getOptions } from 'redux-first-router';
import { DepictProvider } from '@depict-ai/react-ui';
// eslint-disable-next-line camelcase
import { en_GB, sv_SE } from '@depict-ai/react-ui/locales';
import Header from './Header/Header';
import Switcher from './Switcher';
import Footer from './Footer/Footer';
import { fetchData } from '../utils/async';
import { prefix } from '../utils/string';
import '../index.scss';

const App = ({ setup, productCache, store }) => {
	const { market, pricelist, language } = setup;

	const navigate = (to, options) => {
		if (options.replace) {
			// replace(to);
			window.history.replaceState({}, '', to);
			return;
		}

		const { querySerializer } = getOptions();
		const routesMap = selectLocationState(store.getState()).routesMap;
		const url = history().createHref({
			pathname: to,
		});
		const action = pathToAction(url, routesMap, querySerializer);
		store.dispatch(action);
	};

	const displayTransformers = {
		products: (options) => {
			let cache = productCache?.[market]?.[pricelist];
			if (!cache) cache = fetchData(`filter-cache/${market}/${pricelist}/`, {});
			else cache = Promise.resolve(cache);

			return options.displays.map((display) => ({
				...display,
				variant_displays: display.variant_displays.map((variant) => ({
					...variant,
					page_url: `${prefix(setup, '/')}/`,
					cacheData: cache.then((resolvedCache) => Object.keys(resolvedCache.products).filter((p) => resolvedCache.products[p].sku === variant.item_group_id).reduce((acc, p) => resolvedCache.products[p], {})),
				})),
			}));
		},
		categories: (options) => (
			options.data.map((categoryDisplay) => ({
				...categoryDisplay,
				page_url: prefix(setup, `${categoryDisplay.canonicalUri || ''}${categoryDisplay.ancestors.length > 0 ? `${categoryDisplay.ancestors.map((a) => a.slug).join('/')}/` : ''}${categoryDisplay.slug}`),
			}))
		),
	};

	// eslint-disable-next-line camelcase
	const locale = language === 'sv' ? sv_SE : en_GB;

	return (
		<DepictProvider merchant="aplace" market="se" locale={locale} navigateFunction={navigate} displayTransformers={displayTransformers}>
			<div id="app">
				<Header />
				<Switcher />
				<Footer />
			</div>
		</DepictProvider>
	);
};

const mapState = ({ environment, productCache }, props) => ({
	setup: environment.setup,
	productCache,
	...props,
});

export default connect(mapState)(App);
